import { Flex, Text } from '@cmpsr/components';

type DashboardHeaderTitleProps = {
  name?: string;
};

export default function DashboardHeaderTitle(props: DashboardHeaderTitleProps) {
  return (
    <Flex direction="column" alignItems="flex-start" w={{ base: 'full', md: 'auto' }} maxW={{ md: '750px' }}>
      <Text as="h1" variant="text-header-4XL" mb={2} color="tan">
        Welcome
        {props.name ? (
          <Text as="span" textStyle="text-header-4xl-v" color="tan">
            {' '}
            {props.name}
          </Text>
        ) : null}
      </Text>
    </Flex>
  );
}
